const Joi = require("joi");

const homePageIntegrationSchema = (data) => {
  const schema = Joi.object({
    /*******************  Banner *********************/
    bannerTitle: Joi.string()
      .trim()
      // .pattern(new RegExp('^[a-zA-Z0-9,-.?/" ]*$'))
      .pattern(new RegExp("^[a-zA-Z0-9,.?/\" _@'-]*$"))
      .max(50)
      .required()
      .messages({
        "string.pattern.base": "Please enter Valid Title.",
        "string.empty": "Please enter Title.",
        "string.max": "Max length is 50.",
        "any.required": "Please enter Title.",
      }),

    bannerButtonLabel: Joi.string()
      .trim()
      // .pattern(new RegExp('^[a-zA-Z0-9,.?/" ]*$'))
      .pattern(new RegExp("^[a-zA-Z0-9,.?/\" _@'-]*$"))
      .max(50)
      .required()
      .messages({
        "string.pattern.base": "Please enter Valid Label.",
        "string.empty": "Please enter Label.",
        "string.max": "Max length is 50.",
        "any.required": "Please enter Label.",
      }),

    // bannerButtonUrl: Joi.string()
    //   .trim()
    //   .pattern(new RegExp('^[a-zA-Z0-9,.?/" ]*$'))
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Please enter Valid URL.",
    //     "string.empty": "Please enter URL.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter URL.",
    //   }),

    // bannerButtonUrl: Joi.string()
    //   .trim()
    //   .pattern(new RegExp("^[a-zA-Z0-9]+(?:[- ][a-zA-Z0-9]+)*$"))
    //   .required()
    //   .messages({
    //     "string.pattern.base":
    //       "Only letters, numbers, spaces, and hyphens (-) are allowed. Hyphens cannot be at the start or end.",
    //     "string.empty": "Please enter URL.",
    //     "any.required": "Please enter URL.",
    //   }),

    bannerButtonUrl: Joi.string()
      .uri()
      .max(2000) // adjust if needed
      .required()
      .messages({
        "string.uri": "Please enter a valid URL.",
        "string.empty": "Please enter URL.",
        "string.max": "Max length is 2000.",
        "any.required": "Please enter URL.",
      }),

    bannerDescription: Joi.string()
      .trim()
      .min(1)
      .custom((value, helpers) => {
        const strippedContent = value
          .replace(/<\/?[^>]+(>|$)/g, "")
          .replace(/&nbsp;/g, "")
          .replace(/\s+/g, "")
          .trim();

        if (!strippedContent || strippedContent.length === 0) {
          return helpers.message("Please enter Description.");
        }

        return value;
      })
      .required()
      .messages({
        "string.empty": "Please enter Description.",
        "any.required": "Please enter Description.",
        "string.min": "Please enter Description.",
      }),

    /*******************  Sec-1 *********************/

    // sectionOneTitle: Joi.string()
    //   .trim()
    //   .pattern(new RegExp('^[a-zA-Z0-9,.?/" ]*$'))
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Please enter Valid Title.",
    //     "string.empty": "Please enter Title.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter Title.",
    //   }),

    // sectionOneDescription: Joi.string()
    //   .trim()
    //   .min(1)
    //   .custom((value, helpers) => {
    //     const strippedContent = value
    //       .replace(/<\/?[^>]+(>|$)/g, "")
    //       .replace(/&nbsp;/g, "")
    //       .replace(/\s+/g, "")
    //       .trim();

    //     if (!strippedContent || strippedContent.length === 0) {
    //       return helpers.message("Please enter Description.");
    //     }

    //     return value;
    //   })
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Description.",
    //     "any.required": "Please enter Description.",
    //     "string.min": "Please enter Description.",
    //   }),

    /*******************  Sec-2 *********************/
    // contentSectionOneTitle: Joi.string()
    //   .trim()
    //   .pattern(new RegExp('^[a-zA-Z0-9,.?/" ]*$'))
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Please enter Valid Title.",
    //     "string.empty": "Please enter Title.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter Title.",
    //   }),

    // contentSectionOneDescription: Joi.string()
    //   .trim()
    //   .min(1)
    //   .custom((value, helpers) => {
    //     const strippedContent = value
    //       .replace(/<\/?[^>]+(>|$)/g, "")
    //       .replace(/&nbsp;/g, "")
    //       .replace(/\s+/g, "")
    //       .trim();

    //     if (!strippedContent || strippedContent.length === 0) {
    //       return helpers.message("Please enter Description.");
    //     }

    //     return value;
    //   })
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Description.",
    //     "any.required": "Please enter Description.",
    //     "string.min": "Please enter Description.",
    //   }),
    // contentSectionTwoTitle: Joi.string()
    //   .trim()
    //   .pattern(new RegExp('^[a-zA-Z0-9,.?/" ]*$'))
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Please enter Valid Title.",
    //     "string.empty": "Please enter Title.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter Title.",
    //   }),

    // contentSectionTwoDescription: Joi.string()
    //   .trim()
    //   .min(1)
    //   .custom((value, helpers) => {
    //     const strippedContent = value
    //       .replace(/<\/?[^>]+(>|$)/g, "")
    //       .replace(/&nbsp;/g, "")
    //       .replace(/\s+/g, "")
    //       .trim();

    //     if (!strippedContent || strippedContent.length === 0) {
    //       return helpers.message("Please enter Description.");
    //     }

    //     return value;
    //   })
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Description.",
    //     "any.required": "Please enter Description.",
    //     "string.min": "Please enter Description.",
    //   }),
    // contentSectionThreeTitle: Joi.string()
    //   .trim()
    //   .pattern(new RegExp('^[a-zA-Z0-9,.?/" ]*$'))
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Please enter Valid Title.",
    //     "string.empty": "Please enter Title.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter Title.",
    //   }),

    // contentSectionThreeDescription: Joi.string()
    //   .trim()
    //   .min(1)
    //   .custom((value, helpers) => {
    //     const strippedContent = value
    //       .replace(/<\/?[^>]+(>|$)/g, "")
    //       .replace(/&nbsp;/g, "")
    //       .replace(/\s+/g, "")
    //       .trim();

    //     if (!strippedContent || strippedContent.length === 0) {
    //       return helpers.message("Please enter Description.");
    //     }

    //     return value;
    //   })
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Description.",
    //     "any.required": "Please enter Description.",
    //     "string.min": "Please enter Description.",
    //   }),
    /*******************  Sec-3 *********************/
    downloadSectionMainTitle: Joi.string()
      .trim()
      .pattern(new RegExp("^[a-zA-Z0-9' -]*$"))
      .max(50)
      .required()
      .messages({
        "string.pattern.base": "Please enter Valid Title.",
        "string.empty": "Please enter Title.",
        "string.max": "Max length is 50.",
        "any.required": "Please enter Title.",
      }),

    downloadFirstCardTitle: Joi.string()
      .trim()
      .pattern(new RegExp('^[a-zA-Z0-9,-.?/" ]*$'))
      .max(50)
      .required()
      .messages({
        "string.pattern.base": "Please enter Valid Title.",
        "string.empty": "Please enter Title.",
        "string.max": "Max length is 50.",
        "any.required": "Please enter Title.",
      }),
    downloadSecondCardTitle: Joi.string()
      .trim()
      .pattern(new RegExp('^[a-zA-Z0-9,-.?/" ]*$'))
      .max(50)
      .required()
      .messages({
        "string.pattern.base": "Please enter Valid Title.",
        "string.empty": "Please enter Title.",
        "string.max": "Max length is 50.",
        "any.required": "Please enter Title.",
      }),
    downloadThirdCardTitle: Joi.string()
      .trim()
      .pattern(new RegExp('^[a-zA-Z0-9,-.?/" ]*$'))
      .max(50)
      .required()
      .messages({
        "string.pattern.base": "Please enter Valid Title.",
        "string.empty": "Please enter Title.",
        "string.max": "Max length is 50.",
        "any.required": "Please enter Title.",
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = homePageIntegrationSchema;
